(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const STORE = (window.FF_STORE !== undefined) ? window.FF_STORE : 'https://flight-foods.com';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('js');

  /* ---------- Product config ---------- */
  // FF_PRODUCT: { name, variants:[{ id, title, price, compare, plan, planName, subPrice, slide, facts, doses, noCompare }] }
  // FF_LIVE (Shopify only): live price / compare / selling plans per variant id, overrides the static values.
  const RAW = window.FF_PRODUCT || { name: 'Blessed Berry', vid: 51835429421330, price: 47.99, compare: 49.99, subPrice: 43.19, plan: 694904914194 };
  const VARS = (RAW.variants || [{ id: RAW.vid, price: RAW.price, compare: RAW.compare, plan: RAW.plan, subPrice: RAW.subPrice }]).map(v => {
    const live = (window.FF_LIVE || {})[v.id];
    if (!live) return v;
    const o = Object.assign({}, v, { price: live.price, compare: live.compare, available: live.available });
    const plans = live.plans || [];
    const pick = plans.find(p => p.id === v.plan) || plans[0];
    if (pick) { o.plan = pick.id; o.subPrice = pick.price; o.planName = pick.name; } else { o.plan = null; }
    return o;
  });
  const ADD = window.FF_ADD || { crown: { vid: 50300273819922, price: 44.99 }, profuel: { vid: 50300248490258, price: 59.99 } };
  const FREE = 75;
  const money = n => '$' + n.toFixed(2);
  const params = new URLSearchParams(location.search);
  let vi = Math.max(0, VARS.findIndex(v => String(v.id) === params.get('variant')));
  let P = VARS[vi];

  const qtyIn = $('#qty'), label = $('#atcLabel'), form = $('#atcForm'), fields = $('#atcFields');
  // Purchase options (bundles 1/2/3 and subscription) come from the Kaching app block when it is on the page.
  const appBlock = () => document.querySelector('kaching-bundle, kaching-bundles-block, [class*="kaching-bundles"], .shopify-app-block[id*="kaching"]');
  fields.innerHTML = '<input type="hidden" name="id" value=""><input type="hidden" name="quantity" value="1">';
  const idIn = $('input[name=id]', fields), qIn = $('input[name=quantity]', fields);
  const spIn = () => form.querySelector('[name=selling_plan]');
  const plan = () => (spIn() && spIn().value && P.plan && String(spIn().value) === String(P.plan)) ? 'sub' : 'once';
  const qty = () => Math.max(1, Math.min(10, parseInt(appBlock() ? qIn.value : qtyIn.value, 10) || 1));
  const extras = () => $$('.upsell input:checked').map(i => i.value);
  const unit = () => plan() === 'sub' && P.plan ? P.subPrice : P.price;
  const total = () => unit() * qty() + extras().reduce((s, k) => s + ADD[k].price, 0);
  const setTxt = (id, t) => { const e = document.getElementById(id); if (e) e.textContent = t; };

  function applyVariant(first) {
    P = VARS[vi];
    $$('.pvar:not(.pvar--links) .pvar__opt').forEach((b, k) => { b.classList.toggle('is-on', k === vi); b.setAttribute('aria-checked', k === vi); });
    setTxt('pvarName', P.title || '');
    if (P.doses) $$('#doses li').forEach((li, k) => { const d = P.doses[k]; if (d) { $('b', li).textContent = d[0]; $('span', li).textContent = d[1]; } });
    if (P.facts) { const fi = $('#facts img'); if (fi) fi.src = P.facts; }
    $$('[data-vtext]').forEach(el => { const t = (P.text || {})[el.dataset.vtext]; if (t) el.textContent = t; });
    if (!first && typeof P.slide === 'number' && window.__ffGo) window.__ffGo(P.slide);
    if (!first && VARS.length > 1 && history.replaceState) { const u = new URL(location.href); u.searchParams.set('variant', P.id); history.replaceState(null, '', u); }
    const oos = P.available === false;
    $('#atc').disabled = oos; if (oos) label.textContent = 'Sold out';
  }
  function render() {
    const app = !!appBlock();
    document.documentElement.classList.toggle('ff-has-app', app);
    const t = total();
    if (P.available !== false) label.textContent = app ? 'Add to cart' : `Add to cart \u00b7 ${money(t)}`;
    const left = FREE - t;
    $('#shipFill').style.width = Math.min(100, t / FREE * 100) + '%';
    $('#shipMsg').textContent = left > 0 ? `You're ${money(left)} away from free shipping` : 'You unlocked free shipping.';
    $('#shipMsg').classList.toggle('is-done', left <= 0);
    const st = $('#psPrice'); if (st) st.textContent = money(unit()) + (plan() === 'sub' && P.plan ? ' \u00b7 subscribe & save' : '');
    const fc = $('#finalCta'); if (fc) { fc.dataset.label = fc.dataset.label || fc.textContent.split(' \u00b7 ')[0]; fc.textContent = `${fc.dataset.label} \u00b7 ${money(unit())}`; }
    // standard product form fields (id, quantity) so the Kaching app can read and adjust them;
    // optional stack add-ons ride along as data and are added in a separate request by cart.js
    const vid = String(P.id || P.vid);
    if (idIn.value !== vid) { idIn.value = vid; idIn.dispatchEvent(new Event('change', { bubbles: true })); }
    if (!app) qIn.value = qty();
    form.dataset.extras = extras().map(k => ADD[k].vid).join(',');
  }
  $$('.pvar:not(.pvar--links) .pvar__opt').forEach((b, k) => b.addEventListener('click', () => { if (k === vi) return; vi = k; applyVariant(false); render(); }));
  const pv = $('.pvar:not(.pvar--links) .pvar__opts');
  if (pv) pv.addEventListener('keydown', e => {
    if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
    e.preventDefault(); const n = $$('.pvar__opt', pv); const k = (vi + (/Right|Down/.test(e.key) ? 1 : n.length - 1)) % n.length; n[k].focus(); n[k].click();
  });
  form.addEventListener('change', e => { if (e.target !== idIn) render(); });
  // the app block loads after us; re-render once it appears so labels and the stepper adapt
  if (!appBlock() && 'MutationObserver' in window) {
    const mo = new MutationObserver(() => { if (appBlock()) { mo.disconnect(); render(); } });
    mo.observe(document.body, { childList: true, subtree: true }); setTimeout(() => mo.disconnect(), 15000);
  }
  $$('.upsell input').forEach(i => i.addEventListener('change', render));
  $('#qMinus').addEventListener('click', () => { qtyIn.value = qty() - 1; render(); });
  $('#qPlus').addEventListener('click', () => { qtyIn.value = qty() + 1; render(); });
  qtyIn.addEventListener('change', () => { qtyIn.value = qty(); render(); });
  form.action = STORE + '/cart/add';
  form.addEventListener('submit', () => $('#atc').classList.add('is-busy'));
  applyVariant(true);
  render();

  /* ---------- Gallery ---------- */
  const slides = $$('.gal__slide'), thumbs = $$('.gal__thumb');
  let cur = 0;
  const go = i => {
    cur = (i + slides.length) % slides.length;
    slides.forEach((s, k) => s.classList.toggle('is-on', k === cur));
    thumbs.forEach((t, k) => { t.classList.toggle('is-on', k === cur); t.setAttribute('aria-selected', k === cur); });
  };
  window.__ffGo = go;
  if (typeof P.slide === 'number' && P.slide) go(P.slide);
  thumbs.forEach((t, k) => t.addEventListener('click', () => go(k)));
  $('#galPrev').addEventListener('click', () => go(cur - 1));
  $('#galNext').addEventListener('click', () => go(cur + 1));
  let sx = null;
  const main = $('.gal__main');
  main.addEventListener('touchstart', e => { sx = e.touches[0].clientX; }, { passive: true });
  main.addEventListener('touchend', e => { if (sx === null) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); sx = null; });

  /* ---------- Supplement facts dialog ---------- */
  const dlg = $('#facts');
  $('#factsBtn').addEventListener('click', () => dlg.showModal());
  $('#factsX').addEventListener('click', () => dlg.close());
  dlg.addEventListener('click', e => { if (e.target === dlg) dlg.close(); });

  /* ---------- Sticky ATC ---------- */
  const sticky = $('#psticky'), buy = $('.cta-row');
  $('#psBtn').addEventListener('click', e => { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.submit(); });
  const nav = $('#nav'); let lastY = 0;
  const onScroll = () => {
    const y = scrollY;
    const past = buy.getBoundingClientRect().bottom < 0;
    const atEnd = $('.pfinal').getBoundingClientRect().top < innerHeight * .75;
    const on = past && !atEnd;
    sticky.classList.toggle('is-on', on); sticky.setAttribute('aria-hidden', !on); $('#psBtn').tabIndex = on ? 0 : -1;
    nav.classList.toggle('is-scrolled', y > 10);
    nav.classList.toggle('is-hidden', y > 600 && y > lastY + 4 && !nav.classList.contains('menu-open') && !nav.querySelector('.dd.is-open'));
    if (y < lastY - 4) nav.classList.remove('is-hidden');
    lastY = y;
  };
  addEventListener('scroll', onScroll, { passive: true }); onScroll();

  /* ---------- Nav dropdowns + mobile menu ---------- */
  (function navMenu() {
    const dds = $$('.dd', nav), burger = $('#burger');
    const hover = matchMedia('(hover:hover) and (min-width:961px)');
    const close = (except) => dds.forEach(d => { if (d !== except) { d.classList.remove('is-open'); $('.dd__btn', d).setAttribute('aria-expanded', 'false'); } });
    dds.forEach(d => {
      const btn = $('.dd__btn', d); let t;
      const open = () => { close(d); d.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
      btn.addEventListener('click', () => d.classList.contains('is-open') ? close() : open());
      d.addEventListener('pointerenter', () => { if (hover.matches) { clearTimeout(t); open(); } });
      d.addEventListener('pointerleave', () => { if (hover.matches) t = setTimeout(() => close(), 160); });
      d.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); btn.focus(); } });
    });
    document.addEventListener('click', e => { if (!nav.contains(e.target)) close(); });
    const setMenu = (on) => { nav.classList.toggle('menu-open', on); burger.setAttribute('aria-expanded', on); burger.setAttribute('aria-label', on ? 'Close menu' : 'Open menu'); document.body.style.overflow = on ? 'hidden' : ''; };
    burger.addEventListener('click', () => setMenu(!nav.classList.contains('menu-open')));
    $$('.menu a', nav).forEach(a => a.addEventListener('click', () => { setMenu(false); close(); }));
  })();

  /* ---------- Footer signup (validate only) ---------- */
  const fs = $('#footSignup');
  if (fs) fs.addEventListener('submit', e => {
    const inp = $('#footEmail'), msg = $('#footMsg');
    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(inp.value.trim());
    if (!ok || !fs.getAttribute('action')) {
      e.preventDefault();
      msg.classList.toggle('is-err', !ok);
      msg.textContent = ok ? 'You\u2019re on the list.' : 'Please enter a valid email address.';
      if (ok) inp.value = '';
    }
  });

  /* ---------- Reveal motion ---------- */
  const g = window.gsap;
  if (!g || reduce) { $$('.reveal').forEach(el => el.style.opacity = 1); return; }
  g.registerPlugin(window.ScrollTrigger);
  g.from('.pinfo > *', { y: 18, opacity: 0, duration: .8, stagger: .05, ease: 'power3.out' });
  g.from('.gal', { y: 24, opacity: 0, duration: 1, ease: 'power3.out' });
  $$('.reveal').forEach(el => g.fromTo(el, { y: 28, opacity: 0 }, { y: 0, opacity: 1, duration: .9, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 88%', once: true } }));
})();
